import { defineStore } from 'pinia';
import axios from 'axios';

// Client state for the "الاشتراكات والمدفوعات" section password gate.
// The real check is server-side (subs.gate middleware); this only mirrors the
// unlock status so we don't re-prompt on every navigation. `unlocked === null`
// means "unknown" (e.g. after a page refresh) → the guard asks the backend.
export const useSubsGateStore = defineStore('subsGate', {
    state: () => ({
        unlocked: null, // null = unknown, true/false = known
        checking: false,
        submitting: false,
    }),

    actions: {
        // Ask the backend whether this session/token is currently unlocked.
        async checkStatus() {
            this.checking = true;
            try {
                const { data } = await axios.get('/admin/subs-gate/status');
                this.unlocked = !!data.unlocked;
            } catch {
                this.unlocked = false;
            } finally {
                this.checking = false;
            }
            return this.unlocked;
        },

        // Verify the password server-side; on success the section is unlocked.
        async unlock(password) {
            this.submitting = true;
            try {
                const { data } = await axios.post('/admin/subs-gate/unlock', { password });
                this.unlocked = !!data.unlocked;
                return { ok: true };
            } catch (e) {
                this.unlocked = false;
                return { ok: false, message: e?.response?.data?.message || 'كلمة المرور غير صحيحة' };
            } finally {
                this.submitting = false;
            }
        },

        // Called on logout (and when the backend reports the gate is required).
        reset() {
            this.unlocked = null;
        },
    },
});
